import React from "react";
import "../Styles/ServicesHeader.css";

const ServicesHeader = () => {
  return (
    <div className="services-header">
      <h2 className="services-title">
        Services
        <span className="underline"></span>
      </h2>
      <p className="services-description">
        We use only the best quality materials on the market in order to <br />
        provide the best products to our patients.
      </p>
    </div>
  );
};

export default ServicesHeader;
